export const isCurrUserAdmin = () => {
    const userData = localStorage.getItem("loggedInUser");
    if (userData != null) {
      const loggedInUser = JSON.parse(userData);
      return loggedInUser?.typeOfUser.includes("admin")
    }
}